export default __webpack_public_path__ + "static/media/head-secretary.5de4fe40.jpg";